import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnkleBoots = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.375 15.25V7.125V4.625C21.375 4.27995 21.095 4 20.75 4C20.4049 4 20.125 4.27995 20.125 4.625V6.5H14.1118C13.849 6.5 13.6146 6.66479 13.5242 6.91178C13.508 6.95736 11.8165 11.5 8.68864 11.5C6.12994 11.4647 3.87169 12.9645 2.84992 15.25H2.625C2.27995 15.25 2 15.53 2 15.875V18.375C2 18.72 2.27995 19 2.625 19H21.375C21.72 19 22 18.72 22 18.375V15.875C22 15.53 21.72 15.25 21.375 15.25ZM8.68091 12.75C12.0818 12.75 13.9832 9.02198 14.5334 7.75H20.125V15.25H4.24452C5.16167 13.7045 6.85122 12.7209 8.68091 12.75ZM20.75 17.75H3.25V16.5H20.75V17.75Z",
		fill: "currentColor"
	})
});
export default SvgAnkleBoots;
